import { useMutation, useQueryClient } from '@tanstack/react-query';
import { z } from 'zod';

import { request } from '@/lib/http';
import { certificadoResumoSchema } from '@fiscoai/contracts';

/** O cadastro (detalhe e lista) mostra os dados públicos do certificado: recarrega os dois. */
function useAtualizarEmpresa(empresaId: string) {
  const cliente = useQueryClient();
  return () => {
    void cliente.invalidateQueries({ queryKey: ['empresas', 'detalhe', empresaId] });
    void cliente.invalidateQueries({ queryKey: ['empresas'], refetchType: 'none' });
    void cliente.invalidateQueries({ queryKey: ['pendencias'] });
  };
}

/**
 * Envio (ou troca) do A1: o arquivo e a senha vão uma única vez, por multipart. `gcTime: 0` e o
 * `reset()` do formulário tiram a senha do cache do React Query assim que o envio termina.
 */
export function useEnviarCertificado(empresaId: string) {
  const atualizar = useAtualizarEmpresa(empresaId);
  return useMutation({
    gcTime: 0,
    mutationFn: ({ arquivo, senha }: { arquivo: File; senha: string }) => {
      const corpo = new FormData();
      corpo.append('senha', senha);
      corpo.append('arquivo', arquivo);
      return request(`/empresas/${empresaId}/certificado`, {
        method: 'PUT',
        body: corpo,
        schema: certificadoResumoSchema,
      });
    },
    onSuccess: atualizar,
  });
}

export function useRemoverCertificado(empresaId: string) {
  const atualizar = useAtualizarEmpresa(empresaId);
  return useMutation({
    mutationFn: () =>
      request(`/empresas/${empresaId}/certificado`, { method: 'DELETE', schema: z.unknown() }),
    onSuccess: atualizar,
  });
}
